/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */
import { Playground, Props } from 'docz'
import Dialog from './'
import Button from '../../../core/components/button'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "dialog"
    }}>{`Dialog`}</h1>
    <p>{`Opinionated wrapper around `}<a parentName="p" {...{
        "href": "http://reactcommunity.org/react-modal/"
      }}>{`react-modal`}</a>{`,
an accessible modal dialog component for React.`}</p>
    <p>{`The only required prop is `}<inlineCode parentName="p">{`isOpen`}</inlineCode>{`, which is a toggle for displaying the dialog.
See `}<a parentName="p" {...{
        "href": "http://reactcommunity.org/react-modal/"
      }}>{`react-modal`}</a>{` for details and general usage.`}</p>
    <p>{`Note you must call `}<inlineCode parentName="p">{`Dialog.setAppElement(element)`}</inlineCode>{` `}<em parentName="p">{`before`}</em>{` the first use of this
component in your app, where `}<inlineCode parentName="p">{`element`}</inlineCode>{` is the html element, or id thereof, of your
app root. Alternatively, pass in the `}<inlineCode parentName="p">{`appElementId`}</inlineCode>{` prop on the first use.`}</p>
    <p><inlineCode parentName="p">{`Dialog`}</inlineCode>{` will ignore any styles passed in via react-modal's `}<inlineCode parentName="p">{`style`}</inlineCode>{` prop. Instead
certain styles can be configured via styled-system props (see table below) and
the rest are hard-coded opinions within the `}<inlineCode parentName="p">{`Dialog`}</inlineCode>{` component.`}</p>
    <p>{`Notable props include `}<inlineCode parentName="p">{`opacity`}</inlineCode>{` for adjusting the scrim opacity, `}<inlineCode parentName="p">{`boxShadow`}</inlineCode>{` for
setting the dialog drop shadow, and `}<inlineCode parentName="p">{`closeTimeoutMS`}</inlineCode>{` for adjusting the transition
timing. Transitions are hard-coded for now. Only the timing is adjustable.`}</p>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <p>{`Set `}<inlineCode parentName="p">{`isOpen`}</inlineCode>{` to `}<inlineCode parentName="p">{`true`}</inlineCode>{` below to trigger the dialog. There's no way to close it
in docz, so refresh when you're done.`}</p>
    <Playground __position={0} __code={'<Dialog isOpen={false} width=\"50%\" height=\"50%\" appElementId=\"root\">\n  <Button block>Howdy ho</Button>\n</Dialog>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Dialog,
      Button
    }} mdxType="Playground">
    <Dialog isOpen={false} width="50%" height="50%" appElementId="root" mdxType="Dialog">
        <Button block mdxType="Button">Howdy ho</Button>
    </Dialog>
    </Playground>
    <h3 {...{
      "id": "proptypes"
    }}>{`PropTypes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Prop`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`appElementId`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`id of app root element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`isOpen`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bool`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`onAfterOpen`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`func`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`onRequestClose`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`func`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`closeTimeoutMS`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`150`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`contentLabel`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`portalClassName`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`modal-dialog`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`overlayClassName`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`{ base: 'modal-dialog__overlay', afterOpen: 'modal-dialog__overlay--after-open', beforeClose: 'modal-dialog__overlay--before-close'}`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`className`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`{base: 'modal-dialog__content', afterOpen: 'modal-dialog__content--after-open', beforeClose: 'modal-dialog__content--before-close'}`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bodyOpenClassName`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`body--modal-dialog-open`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`htmlOpenClassName`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ariaHideApp`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bool`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`shouldFocusAfterRender`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bool`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`shouldCloseOnOverlayClick`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bool`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`shouldCloseOnEsc`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bool`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`shouldReturnFocusAfterClose`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bool`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`role`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`dialog`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`parentSelector`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`func`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`() => document.body`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`aria`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`data`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`overlayRef`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`func`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`contentRef`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`func`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`via `}<a parentName="td" {...{
              "href": "http://reactcommunity.org/react-modal/#usage"
            }}>{`react-modal`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Box props`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "/components/box"
            }}>{`Box`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`minWidth`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`30rem`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`maxWidth`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`80%`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`minHeight`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`40rem`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`minHeight`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`90%`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`opacity`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`0.6`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`scrim opacity`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`boxShadow`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`5`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`should be a key in theme shadows`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bg`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`white`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`dialog background`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`border`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`borderColor`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`borderRadius`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  